import { SelectPlus } from 'Components/SelectPlus';

// Filtro utilitario: true -> 'SI', false -> 'NO' (el mapeo ocurre en el backend). Sin selección no filtra.
const UTILITARIAN_OPTIONS = [
  { label: 'Sí', value: true },
  { label: 'No', value: false },
];

export const SelectUtilitarian = ({ ...selectProps }) => (
  <SelectPlus
    placeholder='Seleccionar'
    options={UTILITARIAN_OPTIONS}
    {...selectProps}
  />
);
